export default {
  name: 'Header section - 15',
  tab: 'header',
  type: 'navigation-default-section',
  content: {
    logo: '/storage/media/Logo/combination_logo_outline_transparent.svg',
    menu: 'default'
  },
  design: {
    'background-color': 'var(--primary-color)',
    padding: '15px',
    'logo-width': '150',
    'menu-font-family': 'inherit',
    'menu-text-color': 'var(--text-light-color)',
    'menu-font-size': '14'
  },
  layout: {
    'content-container-fluid': '1',
    centered: '0',
    absolute: '0',
    'absolute-background-opacity': '0',
    'show-toggle': 'lg'
  },
  advanced: {
    'stick-on-scroll': '0',
    'sticky-background-color': 'var(--primary-color)',
    'sticky-background-opacity': '1',
    'active-style': 'default'
  }
}
